import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from "moment-timezone";
import {Moment} from "moment-timezone";

@Component({
  selector: 'app-selected',
  templateUrl: './selected.component.html',
  styleUrls: ['./selected.component.scss']
})
export class SelectedComponent implements OnInit {

  public from: any;

  public till: any;

  public lastTerm: any;

  public firstTerm: any;

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe( params => { this.from = params['from']; this.till = params['till']; this.firstTerm = params['first'], this.lastTerm = params['last'] } );
  }

  toTime(date: any): string{
    return moment(date).format('HH:mm');
  }


  toDate(date: any): string{
    var date;
    date = moment(date).lang("cs").format('dddd - D. M. YYYY')
    return date.charAt(0).toUpperCase() + date.slice(1);
  }

}
